import { SelectableTile, Tooltip } from "@carbon/react";
import { FC, ReactNode } from "react";

import { cn } from "src/utils/string.utils.ts";

export type BlockedDecisionTileProps = {
  value: string;
  title: string;
  description: ReactNode;
  selected: boolean;
  onChange: () => void;
  className?: string;
  "data-decision-input"?: boolean;
  tabIndex?: number;
  "aria-pressed"?: boolean;
  blocked: boolean;
  blockedReason?: string;
};

export const BlockedDecisionTile: FC<BlockedDecisionTileProps> = ({
  value,
  title,
  description,
  selected,
  onChange,
  className,
  blocked,
  blockedReason,
  ...rest
}) => {
  const tile = (
    <SelectableTile
      key={value}
      value={value}
      title={title}
      data-decision-input
      selected={selected}
      disabled={blocked}
      onChange={onChange}
      className={cn("h-full w-full overflow-hidden", className)}
      aria-pressed={selected}
      aria-disabled={blocked}
      {...rest}
    >
      <div className="font-normal text-lg mb-2">{title}</div>
      <div className="text-gray-600 text-sm">{description}</div>
    </SelectableTile>
  );

  if (blocked && blockedReason) {
    return (
      <div className="h-[10rem] min-w-0 flex-1">
        <Tooltip
          align="bottom-left"
          as="div"
          label={blockedReason}
          className="flex h-full w-full [&>div]:block [&>div]:h-full [&>div]:w-full"
        >
          <div className="h-full w-full">{tile}</div>
        </Tooltip>
      </div>
    );
  }

  return <div className="min-w-0 flex-1">{tile}</div>;
};
